import React, { useCallback, useEffect, useMemo, useState } from "react";
import Switch from "@mui/material/Switch";
import { Link } from "react-router-dom";
import DataTable from "../_Components/DataTable";
import SwalMessage from "../_Components/SwalMessage";
import _ from "lodash";
import * as XLSX from "xlsx";
import { Button, Col, FormControl, Modal, Row } from "react-bootstrap";
import ApiPromoCategory from "../../../core/api/api.promocategory";
import ApiAmusementService from "../../../core/api/api.amusementService";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import Swal from "sweetalert2";

function DataGridAmusementServicePromoCategory({ data, setShowModalPromoCategory, setSelectedOffer, cities }) {
  const [showModalUploadFile, setShowModalUploadFile] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState();
  const [selectedPromoCategoryName, setSelectedPromoCategoryName] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false); //loading
  const [selectedRowGrid, setSelectedRowGrid] = useState(false);
  const [selectedCities, setSelectedCities] = useState([{
    "value": 899,
    "label": "کیش"
  }])
  const [listAmusementGroup, setListAmusementGroup] = useState([]);
  const [selectedAmusementGroup, setSelectedListAmusementGroup] = useState([]);

  const [isDownloading, setIsDownloading] = useState(false); //loading
  const handleChange = (name) => (event) => {
    updatePromoCategoryStatus(name);
  };

  useEffect(() => {
    (async () => {
      const data = (await ApiAmusementGroup.getAll({ pageSize: 200, pageNumber: 1 })).data;
      setListAmusementGroup(data)
    })()
  }, [])

  //نمایش داده ها روی اکسل
  const exportToExcel = async (id) => {
    setIsDownloading(true)
    if (!id) return;

    //  گروه تخفیف
    let promoResponse = await ApiPromoCategory.GetPromoCategoryAmusementServiceById(id); //get PromoCategoryAmusmentService List
    //  لیست سرویس‌ها و آیتم‌ها
    let amusementResponse = await ApiAmusementService.getAllServices({
      groupIdList: selectedAmusementGroup.map(city => city.value).join(","),
      cityIdList: selectedCities.map(city => city.value).join(",")
    });

    const services = amusementResponse.map((item) => ({
      serviceId: item.id,
      serviceName: item.name,
      amusementServiceReserveItems: item.amusementServiceReserveItems,
    }));

    const rows = [];

    services.forEach((service) => {
      service.amusementServiceReserveItems.forEach((item) => {
        // پیدا کردن تخفیف مربوطه
        let discountData = promoResponse.find(
          (x) => x.amusementServiceId === service.serviceId,
        );
        let parsedNodes = discountData
          ? JSON.parse(discountData.amusementServiceFormFieldIds)
          : [];

        let node = parsedNodes?.find((n) => n.id === item.id.toString());

        rows.push({
          ServiceId: service.serviceId,
          ItemId: item.id,
          تفریح: service.serviceName,
          آیتم: item.title,
          'قیمت اصلی': item.originalPrice,
          قیمت: item.price,
          'پرداختی به تامین کننده': item.supplierSettlementPrice,
          "تخفیف به تومان": node?.discountprice || "",
        });
      });
    });


    const worksheet = XLSX.utils.json_to_sheet(rows);

    // تنظیم عرض ستون‌ها)
    worksheet["!cols"] = [
      { wch: 10 }, // ServiceId
      { wch: 10 }, , // ItemId
      { wch: 20 }, // تفریح
      { wch: 40 }, // آیتم
      { wch: 15 }, // قیمت اصلی
      { wch: 15 }, // قیمت
      { wch: 20 }, // supplierSettlementPrice
      { wch: 20 }, // DiscountPrice
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Discounts");
    XLSX.writeFile(workbook, `promo-discounts-${id}.xlsx`);
    setIsDownloading(false)
  };
  // وقتی کاربر فایل را انتخاب می‌کند
  const handleFileSelect = (e) => {
    const file = e.target.files[0]; //  اولین فایل
    if (!file.name.includes("discounts")) {
      Swal.fire({
        title: "فایل انتخاب شده مربوط به گروه های تخفیف نمی باشد!", icon: "error", showConfirmButton: true, confirmButtonText: "فهمیدم", customClass: {
          actions: "my-actions",
          confirmButton: "order-2 btn btn-success px-5",
        },
      });
      e.target.value = null; // ریست کردن input فایل
      return;
    }
    if (file) {
      setSelectedFile(file);
    }
  };
  //ارسال فایل اکسل به سرور  
  const handleUpload = async () => {
    if (!selectedFile) {
      Swal.fire({
        title: "لطفاً فایل را انتخاب کنید!", icon: "error", showConfirmButton: true, confirmButtonText: "فهمیدم", customClass: {
          actions: "my-actions",
          confirmButton: "order-2 btn btn-success px-5",
        },
      });
      return;
    }
    try {
      setIsUploading(true);
      const formData = new FormData();
      formData.append("file", selectedFile); // فایل انتخاب‌شده
      formData.append("promoCategoryId", selectedRowId); // 
      const response = await ApiPromoCategory.addOrEditPromoCategoryAmusmentServiceByExcel(formData);
      const title = response.message.split(".")[0]
      const message = response.message.substr(response.message.indexOf("."))
      Swal.fire({
        title, text: message, icon: "success", showConfirmButton: true, confirmButtonText: "فهمیدم", customClass: {
          actions: "my-actions",
          confirmButton: "order-2 btn btn-success px-5",
        },
      });
      handleCloseUploadFileModal();
    }
    catch (err) {
      Swal.fire({
        title: "خطا در آپلود فایل", text: err?.message || "", icon: "error", showConfirmButton: true, confirmButtonText: "فهمیدم", customClass: {
          actions: "my-actions",
          confirmButton: "order-2 btn btn-success px-5",
        },
      });
    }
    finally {
      setIsUploading(false);
    }
  };

  async function updatePromoCategoryStatus(item) {
    const response = await ApiPromoCategory.updatePromoCategoryStatus({ id: item.id, isActive: !item.isActive });
    if (response.succeeded == true) document.getElementById("submitButton").click();
    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }
  const handleCloseUploadFileModal = () => {
    setShowModalUploadFile(false);
    setSelectedFile(null);
    setSelectedRowId(null)
    setSelectedPromoCategoryName(null)
  }

  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "شماره",
      minWidth: 50,
    },
    {
      accessor: "name",
      Header: "نام گروه",
      minWidth: "100px",
    },
    {
      Header: "وضعیت گروه",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.isActive}
            //checked={state.checkedA}
            value="row.original.isActive"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            onChange={handleChange(row.original)}
          />
        </div>
      ),
    },
    {
      accessor: "promoCategoryTypeS",
      Header: "نوع گروه",
      minWidth: "100px",
      align: "center",
    },
    {
      accessor: "createdPersianTime",
      Header: "زمان ایجاد",
      minWidth: "150px",
      Cell: ({ row }) => (
        <div className="ltr">
          {row.original?.createdPersianTime != null ? row.original?.createdPersianTime : "-"}
        </div>
      ),
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 100,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {/* ویرایش */}
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش"
            onClick={() => {
              setSelectedOffer(row.original)
              setShowModalPromoCategory(true)
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
          <Link
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش آیتم های گروه تخفیف"
            to={`/CreateEditAmusementServicePromoCategory/${row.original.id}`}
          >
            <i className="fa fa-list text-small"></i>
          </Link>
          <Button //دکمه ویرایش بالارو روی فایل اکسل باز می کنه
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="دانلود فایل تخفیف ها"
            onClick={() => setSelectedRowGrid(row.original)}
          >
            <i className="fa fa-download text-small"></i>
          </Button>
          <Button // اپلود فایل اکسل بالا
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="آپلود فایل تخفیف ها"
            onClick={() => {
              setShowModalUploadFile(true);
              setSelectedRowId(row.original.id);
              setSelectedPromoCategoryName(row.original.name);
            }}
          >
            <i className="fa fa-upload text-small"></i>
          </Button>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };

  const handleCloseFileModal = useCallback(() => {
    setSelectedRowGrid(null)
  }, [])
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
      {/* کدهای مربوط به مدال آپلود فایل تخفیف */}
      <Modal show={showModalUploadFile} onHide={handleCloseUploadFileModal}>
        <Modal.Header closeButton>
          <Modal.Title>آپلود فایل تخفیف های گروه {selectedPromoCategoryName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input type="file" accept=".xlsx" onChange={handleFileSelect} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseUploadFileModal}>
            بستن
          </Button>
          <Button
            variant="primary"
            onClick={handleUpload}
            disabled={isUploading}   //  در زمان آپلود
          >
            {isUploading ? "در حال ثبت..." : "ثبت"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={selectedRowGrid} onHide={handleCloseFileModal}>
        <Modal.Header closeButton>
          <Modal.Title>دانلود فایل تخفیف های گروه {selectedRowGrid?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="mb-5">
              <SelectComponent
                className=" mt-5"
                placeholder="شهر"
                options={cities}
                isMulti
                onChange={(selectedCities) => {
                  setSelectedCities(selectedCities)
                }}
                value={selectedCities}
              />

            </Col>
            <Col className="mb-5">
              <SelectComponent
                className=" mt-5"
                placeholder="دسته"
                options={listAmusementGroup.map((item) => ({
                  value: item.id,
                  label: item.title,
                }))}
                isMulti
                onChange={(selectedAmusementGroup) => {
                  setSelectedListAmusementGroup(selectedAmusementGroup)
                }}
                value={selectedAmusementGroup}
              />

            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseFileModal}>
            بستن
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              exportToExcel(selectedRowGrid.id, selectedCities)
            }}
            disabled={isDownloading}   //  در زمان دانلود
            className="w-25 mt-2"
          >
            {isDownloading ? "در حال دانلود..." : "دانلود"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default DataGridAmusementServicePromoCategory;
